import React from 'react';
const PeerCardLocation = ({ location }) => {
  return location ? (
    <>
      <li className="card-summary-item">
        <svg className="sprite-icon card-summary-item__icon card-summary-item__icon--map-marker">
          <use href="#icon-map-marker"></use>
        </svg>
        <span className="card-summary-item__text">{location}</span>
      </li>
    </>
  ) : null;
};

export default PeerCardLocation;
